module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "file_030"
    }
  }, [_c('em', [_vm._v("THE F2F AND F3F")])])]), _c('a', {
    attrs: {
      "id": "file_030"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Back on Long Island, a new Grumman fighter was on the drawing board. Discussions about the aircraft that would become the F2F began while Fertile Myrtle was being put through her paces at Anacostia. It didn’t take an aeronautical genius to figure out that a smaller, single-seat version of Myrtle would be a wonder. Even the big XFF-1 could outrun the current frontline navy fighters, all while lugging a pair of aviators and a trio of machine guns.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb82c28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_030.vue
// module id = 141
// module chunks = 0